import { useEffect, useState } from 'react';
// import { getProjectMember } from '@service/apis';

export function useClientType(projectId, getProjectMember) {
  const [internalClients, setInternalClients] = useState([]);
  const [externalClients, setExternalClients] = useState([]);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();
    setIsLoading(true);

    if (projectId) {
      (async () => {
        try {
          const response = await getProjectMember(projectId);
          if (response && response.userList && response.userList.length > 0) {
            setInternalClients(response?.userList?.filter((e) => e.isInternal));
            setExternalClients(
              response?.userList?.filter((e) => !e.isInternal),
            );
          }
          setIsLoading(false);
        } catch (error) {
          if (isAbortError(error)) {
            return;
          }
          setError(error);
          setIsLoading(false);
        }
      })();
    }
    return () => {
      abortController.abort();
    };
  }, [projectId]);

  return { internalClients, externalClients, error, isLoading };
}

// type guards
function isAbortError(error) {
  if (error && error.name === 'AbortError') {
    return true;
  }
  return false;
}
